import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { MaterialIconComponent } from '../../../material-icon/material-icon.component';

@Component({
  selector: 'shared-core-error-toast',
  imports: [MaterialIconComponent, NgOptimizedImage],
  templateUrl: './error-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorToastComponent {
  readonly message = input.required<string>();

  closeToast = output();
}
